enum Events {
	Processing = 'file-uploader-is-processing',
}

type EventPayloads = {
	[Events.Processing]: boolean;
};

export { Events, EventPayloads };
